import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.ul`
  flex-grow: 1;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  min-height: 60px;
  list-style: none;
  padding: 12px 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};

  &:first-child {
    border-top-width: 0;
  }
`;

export const EntryPoint = styled.li`
  padding: 0;
  list-style: none;
`;

export const UserInfo = styled.div`
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('midium150_C1')};
`;

export const Year = styled.div`
  color: ${({ theme }) => theme.colors.gray700};
  ${getFontStyle('midium150_C1')};
`;

export const Salary = styled.div`
  margin-left: auto;
  color: ${({ theme }) => theme.colors.gray900};
  ${getFontStyle('bold120_B3')};
`;

export const InfoWrapper = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-grow: 1;
`;

export const NoData = styled.div`
  color: ${({ theme }) => theme.colors.gray700};
  ${getFontStyle('midium150_B3')};
`;

export const ButtonDelete = styled.button`
  width: 36px;
  background: none;
  border-width: 0;
  padding: 0;
  text-align: right;
`;
